import { Button, PasswordInput, Stack } from "@mantine/core";
import { AlertError, DataGridForm, MicroMClient, useExecuteProcess, ValuesObject } from "@mcurros2/microm";
import { useCallback, useEffect, useRef, useState } from "react";
import { EnviarRecibos } from "../../Entities/EnviarRecibos/EnviarRecibos";

export interface ImportarRecibosMenuProps {
    client: MicroMClient;
}

export default function ImportarRecibosMenu({ client }: ImportarRecibosMenuProps) {
    const [password, setPassword] = useState("");
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [parentKeys, setParentKeys] = useState<ValuesObject>({});

    const enviarRecibosRef = useRef<EnviarRecibos>(new EnviarRecibos(client));
    const enviarRecibos = enviarRecibosRef.current;

    const checkPassword = useExecuteProcess(enviarRecibos, enviarRecibos.def.procs.enre_ComprobarPassword);

    const handleSubmit = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();
        await checkPassword.execute({ vc_password: password });
    }, [password]);

    useEffect(() => {
        if (checkPassword.status.error === undefined && checkPassword.status.data && !checkPassword.status.data.Failed === true) {
            setParentKeys({ vc_password: password });
            setIsAuthorized(true);
        }
    }, [checkPassword.status.error, checkPassword.status.data]);

    const gridHeight = "50vh";

    return (
        <>
            {!isAuthorized ? (
                <form onSubmit={handleSubmit}>
                    <Stack spacing="md" w={300}>
                        <PasswordInput
                            label="Contraseña de supervisor"
                            placeholder="Ingrese la contraseña"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.currentTarget.value)}
                        />
                        <Button
                            type="submit"
                            loading={checkPassword.status.loading}>
                            Confirmar
                        </Button>
                        {checkPassword.status.data?.Failed === true &&
                            <AlertError title="Clave incorrecta.">Ingrese la contraseña correcta.</AlertError>
                        }
                    </Stack>
                </form>
            ) : (
                <DataGridForm
                    gridHeight={gridHeight}
                    entity={enviarRecibos}
                    parentKeys={parentKeys}
                    viewName="enre_brwStandard"
                    selectionMode="multi"
                    enableAdd={false}
                    enableEdit={false}
                    enableDelete={false}
                    enableView={false}
                    showActions={true}
                    showToolbar={true}
                    showActionsToolbar={true}
                    doubleClickAction={"none"}
                    formMode={"edit"} />
            )}
        </>
    );
}